import { render, staticRenderFns } from "./contentCreate.vue?vue&type=template&id=da0d8602&scoped=true"
import script from "./contentCreate.vue?vue&type=script&lang=js"
export * from "./contentCreate.vue?vue&type=script&lang=js"
import style0 from "./contentCreate.vue?vue&type=style&index=0&id=da0d8602&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0d8602",
  null
  
)

export default component.exports